export default [
    { label: 'el-icon-info', value: 'el-icon-info' },
    { label: 'el-icon-error', value: 'el-icon-error' },
    { label: 'el-icon-success', value: 'el-icon-success' },
    { label: 'el-icon-warning', value: 'el-icon-warning' },
    { label: 'el-icon-question', value: 'el-icon-question' },
    { label: 'el-icon-back', value: 'el-icon-back' },
    { label: 'el-icon-arrow-left', value: 'el-icon-arrow-left' },
    { label: 'el-icon-arrow-down', value: 'el-icon-arrow-down' },
    { label: 'el-icon-arrow-right', value: 'el-icon-arrow-right' },
    { label: 'el-icon-arrow-up', value: 'el-icon-arrow-up' },
    { label: 'el-icon-caret-left', value: 'el-icon-caret-left' },
    { label: 'el-icon-caret-bottom', value: 'el-icon-caret-bottom' },
    { label: 'el-icon-caret-top', value: 'el-icon-caret-top' },
    { label: 'el-icon-caret-right', value: 'el-icon-caret-right' },
    { label: 'el-icon-d-arrow-left', value: 'el-icon-d-arrow-left' },
    { label: 'el-icon-d-arrow-right', value: 'el-icon-d-arrow-right' },
    { label: 'el-icon-minus', value: 'el-icon-minus' },
    { label: 'el-icon-plus', value: 'el-icon-plus' },
    { label: 'el-icon-remove', value: 'el-icon-remove' },
    { label: 'el-icon-circle-plus', value: 'el-icon-circle-plus' },
    { label: 'el-icon-remove-outline', value: 'el-icon-remove-outline' },
    { label: 'el-icon-circle-plus-outline', value: 'el-icon-circle-plus-outline' },
    { label: 'el-icon-close', value: 'el-icon-close' },
    { label: 'el-icon-check', value: 'el-icon-check' },
    { label: 'el-icon-circle-close', value: 'el-icon-circle-close' },
    { label: 'el-icon-circle-check', value: 'el-icon-circle-check' },
    { label: 'el-icon-zoom-out', value: 'el-icon-zoom-out' },
    { label: 'el-icon-zoom-in', value: 'el-icon-zoom-in' },
    { label: 'el-icon-d-caret', value: 'el-icon-d-caret' },
    { label: 'el-icon-sort', value: 'el-icon-sort' },
    { label: 'el-icon-sort-down', value: 'el-icon-sort-down' },
    { label: 'el-icon-sort-up', value: 'el-icon-sort-up' },
    { label: 'el-icon-tickets', value: 'el-icon-tickets' },
    { label: 'el-icon-document', value: 'el-icon-document' },
    { label: 'el-icon-goods', value: 'el-icon-goods' },
    { label: 'el-icon-sold-out', value: 'el-icon-sold-out' },
    { label: 'el-icon-news', value: 'el-icon-news' },
    { label: 'el-icon-message', value: 'el-icon-message' },
    { label: 'el-icon-date', value: 'el-icon-date' },
    { label: 'el-icon-printer', value: 'el-icon-printer' },
    { label: 'el-icon-time', value: 'el-icon-time' },
    { label: 'el-icon-bell', value: 'el-icon-bell' },
    { label: 'el-icon-mobile-phone', value: 'el-icon-mobile-phone' },
    { label: 'el-icon-service', value: 'el-icon-service' },
    { label: 'el-icon-view', value: 'el-icon-view' },
    { label: 'el-icon-menu', value: 'el-icon-menu' },
    { label: 'el-icon-more', value: 'el-icon-more' },
    { label: 'el-icon-more-outline', value: 'el-icon-more-outline' },
    { label: 'el-icon-star-on', value: 'el-icon-star-on' },
    { label: 'el-icon-star-off', value: 'el-icon-star-off' },
    { label: 'el-icon-location', value: 'el-icon-location' },
    { label: 'el-icon-location-outline', value: 'el-icon-location-outline' },
    { label: 'el-icon-phone', value: 'el-icon-phone' },
    { label: 'el-icon-phone-outline', value: 'el-icon-phone-outline' },
    { label: 'el-icon-picture', value: 'el-icon-picture' },
    { label: 'el-icon-picture-outline', value: 'el-icon-picture-outline' },
    { label: 'el-icon-delete', value: 'el-icon-delete' },
    { label: 'el-icon-search', value: 'el-icon-search' },
    { label: 'el-icon-edit', value: 'el-icon-edit' },
    { label: 'el-icon-edit-outline', value: 'el-icon-edit-outline' },
    { label: 'el-icon-rank', value: 'el-icon-rank' },
    { label: 'el-icon-refresh', value: 'el-icon-refresh' },
    { label: 'el-icon-share', value: 'el-icon-share' },
    { label: 'el-icon-setting', value: 'el-icon-setting' },
    { label: 'el-icon-upload', value: 'el-icon-upload' },
    { label: 'el-icon-upload2', value: 'el-icon-upload2' },
    { label: 'el-icon-download', value: 'el-icon-download' },
    { label: 'el-icon-loading', value: 'el-icon-loading' }
];
